import { useEffect, useState } from "react";
import { CurrentReservationDto } from "../../../../../api/reservation";
import Pagination from "../../../../../components/web/Pagination";
import {
  ReservationStateHeader,
  ReservationStateItem,
  ReservationStateItemWrapper,
  ReservationStateTableWrapper,
  ReservationStateWrapper,
  ReservationTableHeader,
} from "./style";

export interface ReservationStateProps {
  onClose: () => void;
  currentList: CurrentReservationDto[];
}

const ReservationStateModal = ({
  onClose,
  currentList,
}: ReservationStateProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<CurrentReservationDto[]>([]);
  const limit = 10;

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(currentList.length / limit)));
    setList(currentList.slice((currentPage - 1) * limit, currentPage * limit));
  }, [currentList]);

  useEffect(() => {
    setList(currentList.slice((currentPage - 1) * limit, currentPage * limit));
  }, [currentPage]);

  return (
    <ReservationStateWrapper>
      <ReservationStateHeader>
        <div className="title">예약 현황({currentList.length}명)</div>
        <img
          src="/image-web/reservation/close.svg"
          alt="close"
          onClick={onClose}
        />
      </ReservationStateHeader>
      <ReservationStateTableWrapper>
        <ReservationTableHeader>
          <div className="no">NO.</div>
          <div className="nickname">닉네임</div>
        </ReservationTableHeader>
        <ReservationStateItemWrapper>
          {list.map((current, index) => (
            <ReservationStateItem key={index}>
              <div className="no">{index + 1 + limit * (currentPage - 1)}</div>
              <div className="nickname">{current.nickname}</div>
            </ReservationStateItem>
          ))}
        </ReservationStateItemWrapper>
      </ReservationStateTableWrapper>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        size={22}
      />
    </ReservationStateWrapper>
  );
};

export default ReservationStateModal;
